import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, AlertCircle } from 'lucide-react';
const CART_URL = 'https://omanualproibido.com.br/oferta-especial/?funnel=fn26a5a0d6&step=86&actionId=565400&currentStepId=446780&previousStepId=446768&rda=false&referrer=https%3A%2F%2Fwww.facebook.com%2F';
export function SalesLetterSection() {
  const painPoints = ['Siempre terminás como "el amigo" — el tipo bueno que nunca genera nada.', 'Ves cómo otros tipos (que hacen todo "mal") atraen sin esfuerzo.', 'Tenés miedo de ser directo. De incomodar. De perder lo poco que tenés.', 'Probaste consejos de internet, frases copiadas, y nada funcionó.', 'Sentís que hay algo que todos saben menos vos.'];
  const solutions = ['Entendés exactamente qué genera atracción y qué la destruye.', 'Sabés cómo crear tensión emocional sin manipular ni actuar.', 'Tenés un sistema paso a paso que funciona en cualquier situación.', 'Dejás de adivinar y empezás a actuar con dirección clara.', 'Te convertís en el tipo que ella elige — siendo vos mismo.'];
  const handleCtaClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Manual de Seducción Prohibida',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
  };
  return <section className="py-20 sm:py-28 bg-[#080808] relative overflow-hidden" data-id="element-128">
      <div className="absolute inset-0 opacity-[0.02] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:32px_32px] pointer-events-none" data-id="element-129" />

      <div className="max-w-[800px] mx-auto px-5 sm:px-8 relative z-10" data-id="element-130">
        {/* Opening hook */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-131">
          <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-132">
            Dejame adivinar...
          </p>
          <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-133">
            Hiciste todo bien. Escuchaste. Respetaste. Fuiste paciente. Le
            demostraste que sos un buen tipo. Y aun así... terminaste siendo{' '}
            <span className="text-crimson font-semibold" data-id="element-134">el amigo</span>.
          </p>
          <p className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-135">
            Mientras tanto, ese otro tipo — el que parece no hacer nada especial
            — se lleva toda la atención. Y vos te quedás pensando:{' '}
            <em className="text-white" data-id="element-136">"¿Qué tiene él que no tengo yo?"</em>
          </p>
          <p className="text-lg sm:text-xl text-white leading-relaxed font-medium" data-id="element-137">
            La respuesta te va a sorprender. Y probablemente te va a molestar un
            poco.
          </p>
        </motion.div>

        {/* Divider */}
        <div className="w-16 h-0.5 bg-crimson/40 mx-auto mb-16" data-id="element-138" />

        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-139">
          <div className="flex items-center gap-3 mb-8" data-id="element-140">
            <AlertCircle size={22} className="text-crimson flex-shrink-0" data-id="element-141" />
            <h2 className="text-2xl sm:text-3xl font-black text-white uppercase tracking-wide" data-id="element-142">
              El problema real
            </h2>
          </div>

          <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-143">
            No es que seas feo. No es que no tengas personalidad. No es que "las
            mujeres sean difíciles". El problema es que{' '}
            <span className="text-crimson font-bold" data-id="element-144">
              nadie te enseñó las reglas del juego
            </span>
            . Y sin reglas, estás jugando a ciegas.
          </p>

          <p className="text-lg text-gray-400 leading-relaxed mb-10" data-id="element-145">
            Esto es lo que probablemente te pasa:
          </p>

          {/* Pain points - RED */}
          <div className="space-y-4 mb-12" data-id="element-146">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="flex items-start gap-4 p-4 bg-crimson/5 border border-crimson/10 rounded-lg" data-id="element-147">
                <X size={20} className="text-crimson flex-shrink-0 mt-0.5" data-id="element-148" />
                <p className="text-base sm:text-lg text-gray-200" data-id="element-149">{point}</p>
              </motion.div>)}
          </div>
        </motion.div>

        {/* The Shift */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-150">
          <p className="text-xl sm:text-2xl text-white leading-relaxed font-medium mb-6 text-center" data-id="element-151">
            Pero, ¿y si te dijera que existe un{' '}
            <span className="text-crimson font-bold" data-id="element-152">sistema prohibido</span>{' '}
            que cambia todo esto?
          </p>
          <p className="text-lg text-gray-300 leading-relaxed text-center mb-4" data-id="element-153">
            Un método que los hombres más atractivos del mundo usan
            instintivamente — y que ahora está documentado paso a paso en un
            manual que no deberías estar leyendo.
          </p>
        </motion.div>

        {/* Divider */}
        <div className="w-16 h-0.5 bg-green-500/40 mx-auto mb-16" data-id="element-154" />

        {/* The Solution */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-155">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-4 text-center uppercase tracking-wide" data-id="element-156">
            Con el Manual de Seducción Prohibida:
          </h2>
          <p className="text-gray-400 text-center mb-10" data-id="element-157">
            Esto es lo que cambia cuando entendés cómo funciona la atracción de
            verdad:
          </p>

          {/* Solutions - GREEN */}
          <div className="space-y-4 mb-12" data-id="element-158">
            {solutions.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="flex items-start gap-4 p-4 bg-green-500/5 border border-green-500/10 rounded-lg" data-id="element-159">
                <Check size={20} className="text-green-400 flex-shrink-0 mt-0.5" data-id="element-160" />
                <p className="text-base sm:text-lg text-gray-200" data-id="element-161">{point}</p>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Mid-section CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-162">
          <p className="text-lg text-gold font-semibold mb-6 tracking-wide" data-id="element-163">
            ¿Estás listo para dejar de ser "el amigo"?
          </p>
          <a href={CART_URL} onClick={handleCtaClick} target="_blank" rel="noopener noreferrer" className="inline-block bg-crimson hover:bg-crimson-light text-white font-black text-base py-4 px-10 rounded transition-all duration-300 shadow-[0_0_25px_rgba(220,38,38,0.3)] hover:shadow-[0_0_35px_rgba(220,38,38,0.4)] uppercase tracking-wider" data-id="element-164">
            Sí, quiero el manual ahora
          </a>
        </motion.div>
      </div>
    </section>;
}